import PropTypes from 'prop-types';

export const addUserFormTypes = PropTypes.shape({
  roleId: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string,
  activeInd: PropTypes.bool.isRequired,
});
